import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { TextField } from 'signup/components'
import { Button as ButtonDs } from '@leroy-merlin-br/backyard-react-ui'

const textFieldMarginStyles = ({ theme }) => css`
  label: field_margin;

  margin-bottom: ${theme.spacings.mega};

  ${theme.media.giga} {
    margin-bottom: 0;
  }
`

const buttonStyles = ({ theme }) => css`
  label: button;

  margin-top: ${theme.spacings.mega};
`

export const TextFieldMargin = styled(TextField)(textFieldMarginStyles)
export const Button = styled(ButtonDs)(buttonStyles)
